<script>
  import MileageList from '../../components/mileage/MileageList.svelte'
</script>

<div class="notifications">
  <div class="columns">
    <div class="column">
      <div class="content">
        <MileageList />
      </div>
    </div>
  </div>
</div>
